import { Box } from "@braintrust/braintrust-ui-components";
import { SearchFilter } from "@js/apps/common/components/filters/fields/search-filter";
import { SearchFilterLocationContext } from "@js/apps/common/context/search-filter-location-context";

import style from "./style.module.scss";

export const BidsSearchFilter = () => {
  return (
    <Box
      sx={{
        ml: "auto",
        maxWidth: "200px",
        width: { xs: "100%", lg: "unset" },
        flex: 1,
      }}
    >
      <SearchFilterLocationContext.Provider value="bid_search_box">
        <SearchFilter
          className={style.jobBidsSearchField}
          dataType="BID"
          placeholder="Search by name"
        />
      </SearchFilterLocationContext.Provider>
    </Box>
  );
};
